// Compiled at 2026-05-13T13:50:05.286Z
import { addQueryParametersToUrl } from "@lg/shared";
import * as System from "./System.js";
import * as This from "./System.js";
import { ScreenDefinition } from "@lg/shared";
import { FrontendScreenBridge } from "@lg/ng-shared";

// Auto-generated by Lowgile
export const $ModuleId = 'System.js';

export * from "../../Entity/System/UserIdAndName.js";
export * from "../../Entity/System/BinaryData.js";
export * from "../../UserDefinedConfiguration/System/UserLanguage.js";
export * from "../../Label/System/$translations.js";
export * from "../../Resource/System/$resources.js";
export { $Config } from "../../ConfigurationItem/System/config.js";
export * as $Process from "../../Process/System/$processes.js";
export * from "../../Role/System/$roles.js";
export * from "../../Permission/System/$permissions.js";

export const $Screens = {
};
